import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearExternalMoveDetectedAction = (state: PlanboardState) => {
  state.externalMoveDetected = null;
};
